var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _rect2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 159,
    rx: 7.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 80,
    r: 48,
    fill: "#EEF7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5988,
    cy: 43.9992,
    r: 4.8,
    fill: "#EEF7FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.801,
    cy: 107.6,
    r: 3.6,
    fill: "#EEF7FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 114.801,
    r: 6,
    fill: "#EEF7FE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 59.5996,
    r: 6,
    fill: "#EEF7FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.598,
    cy: 38.6004,
    r: 4.2,
    fill: "#EEF7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_15376_10366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0896 41.5996C66.0481 41.5996 57.1656 46.5614 51.7599 54.1669C49.9952 53.7509 48.1549 53.5307 46.2632 53.5307C33.0842 53.5307 22.4004 64.2145 22.4004 77.3936C22.4004 90.572 33.0829 101.255 46.261 101.256V101.257H105.918C105.918 101.257 105.918 101.257 105.919 101.257C117.45 101.257 126.799 91.9084 126.799 80.3767C126.799 68.845 117.45 59.4967 105.919 59.4967C105.099 59.4967 104.291 59.5439 103.496 59.6357C98.9256 49.0267 88.3749 41.5996 76.0896 41.5996Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.2613,
    cy: 77.3951,
    r: 23.8629,
    fill: "url(#paint0_linear_15376_10366)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0922,
    cy: 71.4282,
    r: 29.8286,
    fill: "url(#paint1_linear_15376_10366)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.917,
    cy: 80.3771,
    r: 20.88,
    fill: "url(#paint2_linear_15376_10366)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_15376_10366)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.2012,
    y: 82.4004,
    width: 33.6,
    height: 33.6,
    rx: 16.8,
    fill: "#2C74D6",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15376_10366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5961 94.3992V92.7992H72.3961V94.3992H75.5961ZM67.5961 96.7992V103.999C67.5961 104.439 67.9561 104.799 68.3961 104.799H79.5961C80.0361 104.799 80.3961 104.439 80.3961 103.999V96.7992C80.3961 96.3592 80.0361 95.9992 79.5961 95.9992H68.3961C67.9561 95.9992 67.5961 96.3592 67.5961 96.7992ZM80.3961 94.3992C81.2841 94.3992 81.9961 95.1112 81.9961 95.9992V104.799C81.9961 105.687 81.2841 106.399 80.3961 106.399H67.5961C66.7081 106.399 65.9961 105.687 65.9961 104.799L66.0041 95.9992C66.0041 95.1112 66.7081 94.3992 67.5961 94.3992H70.7961V92.7992C70.7961 91.9112 71.5081 91.1992 72.3961 91.1992H75.5961C76.4841 91.1992 77.1961 91.9112 77.1961 92.7992V94.3992H80.3961Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 159,
    rx: 7.5,
    stroke: "#EAECF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_15376_10366",
    x: 10.3984,
    y: 41.5996,
    width: 128.4,
    height: 83.6582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_15376_10366"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15376_10366"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_15376_10366"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_15376_10366",
    result: "effect2_dropShadow_15376_10366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_15376_10366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_15376_10366",
    x: 52.4012,
    y: 77.6004,
    width: 43.1996,
    height: 43.1996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_15376_10366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_15376_10366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15376_10366",
    x1: 27.938,
    y1: 61.6286,
    x2: 70.1242,
    y2: 101.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15376_10366",
    x1: 53.1882,
    y1: 51.72,
    x2: 105.921,
    y2: 101.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15376_10366",
    x1: 89.8842,
    y1: 66.5814,
    x2: 126.797,
    y2: 101.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15376_10366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(64.3965 89.5996)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default "data:image/svg+xml,%3csvg width='160' height='160' viewBox='0 0 160 160' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='0.5' y='0.5' width='159' height='159' rx='7.5' fill='white'/%3e %3ccircle cx='74' cy='80' r='48' fill='%23EEF7FE'/%3e %3ccircle cx='23.5988' cy='43.9992' r='4.8' fill='%23EEF7FE'/%3e %3ccircle cx='126.801' cy='107.6' r='3.6' fill='%23EEF7FE'/%3e %3ccircle cx='23' cy='114.801' r='6' fill='%23EEF7FE'/%3e %3ccircle cx='134' cy='59.5996' r='6' fill='%23EEF7FE'/%3e %3ccircle cx='122.598' cy='38.6004' r='4.2' fill='%23EEF7FE'/%3e %3cg filter='url(%23filter0_dd_15376_10366)'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M76.0896 41.5996C66.0481 41.5996 57.1656 46.5614 51.7599 54.1669C49.9952 53.7509 48.1549 53.5307 46.2632 53.5307C33.0842 53.5307 22.4004 64.2145 22.4004 77.3936C22.4004 90.572 33.0829 101.255 46.261 101.256V101.257H105.918C105.918 101.257 105.918 101.257 105.919 101.257C117.45 101.257 126.799 91.9084 126.799 80.3767C126.799 68.845 117.45 59.4967 105.919 59.4967C105.099 59.4967 104.291 59.5439 103.496 59.6357C98.9256 49.0267 88.3749 41.5996 76.0896 41.5996Z' fill='%23EEF7FE'/%3e %3ccircle cx='46.2613' cy='77.3951' r='23.8629' fill='url(%23paint0_linear_15376_10366)'/%3e %3ccircle cx='76.0922' cy='71.4282' r='29.8286' fill='url(%23paint1_linear_15376_10366)'/%3e %3ccircle cx='105.917' cy='80.3771' r='20.88' fill='url(%23paint2_linear_15376_10366)'/%3e %3c/g%3e %3cg filter='url(%23filter1_b_15376_10366)'%3e %3crect x='57.2012' y='82.4004' width='33.6' height='33.6' rx='16.8' fill='%232C74D6' fill-opacity='0.4'/%3e %3cg clip-path='url(%23clip0_15376_10366)'%3e %3cpath d='M75.5961 94.3992V92.7992H72.3961V94.3992H75.5961ZM67.5961 96.7992V103.999C67.5961 104.439 67.9561 104.799 68.3961 104.799H79.5961C80.0361 104.799 80.3961 104.439 80.3961 103.999V96.7992C80.3961 96.3592 80.0361 95.9992 79.5961 95.9992H68.3961C67.9561 95.9992 67.5961 96.3592 67.5961 96.7992ZM80.3961 94.3992C81.2841 94.3992 81.9961 95.1112 81.9961 95.9992V104.799C81.9961 105.687 81.2841 106.399 80.3961 106.399H67.5961C66.7081 106.399 65.9961 105.687 65.9961 104.799L66.0041 95.9992C66.0041 95.1112 66.7081 94.3992 67.5961 94.3992H70.7961V92.7992C70.7961 91.9112 71.5081 91.1992 72.3961 91.1992H75.5961C76.4841 91.1992 77.1961 91.9112 77.1961 92.7992V94.3992H80.3961Z' fill='white'/%3e %3c/g%3e %3c/g%3e %3crect x='0.5' y='0.5' width='159' height='159' rx='7.5' stroke='%23EAECF0'/%3e %3cdefs%3e %3cfilter id='filter0_dd_15376_10366' x='10.3984' y='41.5996' width='128.4' height='83.6582' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='2.4' operator='erode' in='SourceAlpha' result='effect1_dropShadow_15376_10366'/%3e %3cfeOffset dy='4.8'/%3e %3cfeGaussianBlur stdDeviation='2.4'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_15376_10366'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='2.4' operator='erode' in='SourceAlpha' result='effect2_dropShadow_15376_10366'/%3e %3cfeOffset dy='12'/%3e %3cfeGaussianBlur stdDeviation='7.2'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow_15376_10366' result='effect2_dropShadow_15376_10366'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_15376_10366' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_b_15376_10366' x='52.4012' y='77.6004' width='43.1996' height='43.1996' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeGaussianBlur in='BackgroundImageFix' stdDeviation='2.4'/%3e %3cfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_15376_10366'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_15376_10366' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_15376_10366' x1='27.938' y1='61.6286' x2='70.1242' y2='101.258' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_15376_10366' x1='53.1882' y1='51.72' x2='105.921' y2='101.257' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_15376_10366' x1='89.8842' y1='66.5814' x2='126.797' y2='101.257' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3cclipPath id='clip0_15376_10366'%3e %3crect width='19.2' height='19.2' fill='white' transform='translate(64.3965 89.5996)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };